import { useLocation } from 'react-router-dom'
import { pageSEOData } from '../utils/seoData'
import SEO from '../utils/seo'

const RouteMatch = ({ children }) => {
  const location = useLocation()
  const url = location.pathname + location.search
  const matchData = pageSEOData.find(item => item.path === url)
  console.log('matchData', matchData)

  return (
    <>
      <SEO {...matchData} />
      {children}
    </>
  )
}

export default RouteMatch
